window.addEventListener('UC_UI_INITIALIZED', () => {
  const privacySettingsLink = document.getElementById(
    'privacy-settings-footer-link',
  );

  if (privacySettingsLink) {
    privacySettingsLink.addEventListener('click', (event) => {
      event.preventDefault();
      // eslint-disable-next-line no-undef
      UC_UI.showSecondLayer(); // what is UC_UI?
    });
  }
});
